/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Challenge_Is_Over_TitleInputs */

const en_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge Ended`)
};

const ar_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهى الحدث`)
};

const de_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung beendet`)
};

const es_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento finalizado`)
};

const fr_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement terminé`)
};

const it_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento Terminato`)
};

const ja_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント終了`)
};

const ko_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 종료됨`)
};

const pt_br_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento finalizado`)
};

const ru_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие завершено`)
};

const th_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเวนต์สิ้นสุดแล้ว`)
};

const tr_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik Bitti`)
};

const zh_cn_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动已结束`)
};

const zh_tw_challenge_is_over_title = /** @type {(inputs: Challenge_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挑戰已結束`)
};

/**
* | output |
* | --- |
* | "Challenge Ended" |
*
* @param {Challenge_Is_Over_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const challenge_is_over_title = /** @type {((inputs?: Challenge_Is_Over_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Challenge_Is_Over_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_challenge_is_over_title(inputs)
	if (locale === "ar") return ar_challenge_is_over_title(inputs)
	if (locale === "de") return de_challenge_is_over_title(inputs)
	if (locale === "es") return es_challenge_is_over_title(inputs)
	if (locale === "fr") return fr_challenge_is_over_title(inputs)
	if (locale === "it") return it_challenge_is_over_title(inputs)
	if (locale === "ja") return ja_challenge_is_over_title(inputs)
	if (locale === "ko") return ko_challenge_is_over_title(inputs)
	if (locale === "pt_br") return pt_br_challenge_is_over_title(inputs)
	if (locale === "ru") return ru_challenge_is_over_title(inputs)
	if (locale === "th") return th_challenge_is_over_title(inputs)
	if (locale === "tr") return tr_challenge_is_over_title(inputs)
	if (locale === "zh_cn") return zh_cn_challenge_is_over_title(inputs)
	return zh_tw_challenge_is_over_title(inputs)
});